import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class TRCAdminConfigService {

    private resourceUrl = '/api/trc-admin-config';

    constructor(private http: HttpClient) {
    }

    getConfigByCode(code: string): Observable<any> {
        return this.http.get(`${this.resourceUrl}/${code}`);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/trc-admin-config.service.ts